import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import logo from '../../assets/logo.png'
import './NavBar.css'

function NavBar() {

    const [scroll, setScroll] = useState(false)

    const handleScroll = () => {
        if (window.scrollY > 60) {
            setScroll(true)
        } else {
            setScroll(false)
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll)
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    return (
        <nav className={`nav-bar-menu ${scroll ? 'scroll' : ''}`}>
            <Link to='/' className='nav-bar-btn'>
                <img className='nav-bar-logo' src={ logo } alt='Logo'></img>
                <h1>Constructora FQP</h1>
            </Link>
            <Link to='/about'><p  className='nav-bar-btn-p'>Nosotros</p></Link>
            <Link to='/projects'><p className='nav-bar-btn-p'>Proyectos</p></Link>
            <Link to='/contact'><p  className='nav-bar-btn-p'>Contacto</p></Link>
        </nav>
    )
}

export default NavBar